<section class="card">
  <div class="card-body">
    <h2 class="section-heading text-uppercase text-muted small fw-semibold mb-2">Publish Data</h2>
    <div class="d-grid gap-2">
      <div class="mb-1">
        <label for="importMode" class="form-label mb-1 small text-secondary text-uppercase fw-bold">Import Type</label>
        <select id="importMode" class="form-select" (change)="onImportModeChange($event)">
          <option value="model">Trajectories (Compass / Baker)</option>
          <option value="targets">Targets</option>
        </select>
      </div>
      @if (importMode === 'model') {
        <div class="form-check mb-1">
          <input
            id="isOffShore"
            class="form-check-input"
            type="checkbox"
            [checked]="isOffShore"
            (change)="onIsOffShoreChange($event)"
          />
          <label class="form-check-label" for="isOffShore">Offshore well</label>
        </div>
      }
      <div class="mb-1">
        <p class="form-label mb-1 small text-secondary text-uppercase fw-bold">Import Model File</p>
        <button type="button" class="btn btn-outline-primary w-100 d-flex align-items-center justify-content-center gap-2" (click)="openFilePicker()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
            <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z"/>
          </svg>
          Browse for File…
        </button>
        <!-- Fallback for browsers without File System Access API; multiple allowed in model mode -->
        <input #fallbackInput type="file" accept=".xlsx,.xls,.csv" class="d-none"
          [attr.multiple]="importMode === 'model' ? '' : null"
          (change)="onFallbackFileSelected($event)" />
        <div class="form-text mt-1">
          Supports Excel workbooks (.xlsx) and CSV survey exports (.csv).
        </div>
        <p class="status-text small mb-0 mt-1" [class]="modelStatusClass" aria-live="polite">
          {{ modelStatus }}
        </p>
      </div>
      @if (importMode === 'targets' && unresolvedWells.length) {
        <div class="alert alert-warning py-2 px-3 small mb-0" role="alert">
          <strong>Unresolved wells</strong> — these do not match a published wellbore. Publish the well/wellbore first, then re-import.
          <ul class="mb-0 mt-1 ps-3">
            @for (well of unresolvedWells; track well) {
              <li>{{ well }}</li>
            }
          </ul>
        </div>
      }
      @if (importMode === 'targets' && resolutionWarnings.length) {
        <div class="alert alert-warning py-2 px-3 small mb-0" role="alert">
          <strong>Wellbore matching warnings</strong>
          <ul class="mb-0 mt-1 ps-3">
            @for (warning of resolutionWarnings; track warning) {
              <li>{{ warning }}</li>
            }
          </ul>
        </div>
      }
      @if (importMode === 'targets' && templateErrors.length) {
        <div class="alert alert-warning py-2 px-3 small mb-0" role="alert">
          <strong>Validation errors</strong> — validation issues were found. Fix the file and re-import.
          <div class="table-responsive mt-2">
            <table class="table table-sm table-bordered mb-0 bg-white">
              <thead>
                <tr>
                  <th scope="col">Row</th>
                  <th scope="col">Column</th>
                  <th scope="col">Error</th>
                  <th scope="col">Suggested Correction</th>
                </tr>
              </thead>
              <tbody>
                @for (err of templateErrors; track err.row + '|' + err.column + '|' + err.message) {
                  <tr>
                    <td>{{ err.row }}</td>
                    <td>{{ err.column }}</td>
                    <td>{{ err.message }}</td>
                    <td>{{ err.suggestion }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      <button
        class="btn btn-primary"
        [disabled]="publishDisabled"
        (click)="publish()"
      >
        {{ publishLabel }}
      </button>
      @if (publishStatus) {
        <div class="alert py-2 px-3 small mt-1 mb-0" [class]="publishStatusAlertClass" role="status" aria-live="polite">
          {{ publishStatus }}
        </div>
      }
    </div>
  </div>
</section>

